import cx from 'clsx';

import styles from 'theme/components/data-table/table-expand-text.module.scss';

const TableExpandText = ({ children, className, ...other }) => (
  <p {...other} className={cx(styles['table-expand'], className)}>
    {children}
  </p>
);

export default TableExpandText;
